var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('label',{staticClass:"switch"},[_c('input',_vm._g({attrs:{"type":"checkbox"},domProps:{"checked":_vm.value}},_vm.inputListeners)),_c('div',{staticClass:"slider round"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }